module.exports = __webpack_public_path__ + "static/media/cancel.7c0c8a0a.png";